export const API_KEY = {
    POST_VALIDATE_RECOVERY_KEY : `v1/account/validateRecoveryKey`,
    POST_RECOVER_PASSWORD : `v1/account/recoverPassword`
}